"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logAttribute = exports.logAction = exports.logDebug = exports.logInfo = exports.logError = void 0;
function logError(error) {
    console.error(error);
}
exports.logError = logError;
function logInfo(name, data) {
    console.info(`${name}:`, data);
}
exports.logInfo = logInfo;
function logDebug(name, data) {
    console.debug(`${name}:`, data);
}
exports.logDebug = logDebug;
function logAction(name, data) {
    logDebug(name, data);
}
exports.logAction = logAction;
function logAttribute(name, value) {
    logInfo(name, value);
}
exports.logAttribute = logAttribute;
//# sourceMappingURL=Logger.js.map